import { useCallback, useRef, useState } from "react";
import { mediaUrl } from "@/lib/api";

export default function BeforeAfter({ beforeId, afterId, beforeAlt, afterAlt, beforeSrc, afterSrc, testid = "before-after" }) {
  const [pos, setPos] = useState(50);
  const box = useRef(null);
  const dragging = useRef(false);

  const update = useCallback((clientX) => {
    const r = box.current.getBoundingClientRect();
    setPos(Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100)));
  }, []);

  const onKey = (e) => {
    const step = e.shiftKey ? 10 : 2;
    const map = { ArrowLeft: -step, ArrowDown: -step, ArrowRight: step, ArrowUp: step };
    if (map[e.key]) setPos((p) => Math.min(100, Math.max(0, p + map[e.key])));
    else if (e.key === "Home") setPos(0);
    else if (e.key === "End") setPos(100);
    else return;
    e.preventDefault();
  };

  const b = beforeSrc || mediaUrl(beforeId, "lg");
  const a = afterSrc || mediaUrl(afterId, "lg");

  return (
    <div
      ref={box}
      data-testid={testid}
      className="relative aspect-[4/5] w-full select-none overflow-hidden rounded-2xl bg-[var(--powder-light)] touch-none"
      onPointerDown={(e) => { dragging.current = true; e.currentTarget.setPointerCapture(e.pointerId); update(e.clientX); }}
      onPointerMove={(e) => dragging.current && update(e.clientX)}
      onPointerUp={() => { dragging.current = false; }}
      onPointerCancel={() => { dragging.current = false; }}
    >
      <img src={a} alt={afterAlt} width={1200} height={1500} loading="lazy" draggable="false" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={b} alt={beforeAlt} width={1200} height={1500} loading="lazy" draggable="false" className="absolute inset-0 h-full w-full object-cover" />
      </div>
      <span className="pointer-events-none absolute left-3 top-3 rounded-full bg-ink/85 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-[var(--ivory)]">Prima</span>
      <span className="pointer-events-none absolute right-3 top-3 rounded-full bg-ivory/90 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-[var(--ink)]">Dopo</span>
      <div className="pointer-events-none absolute inset-y-0 w-px bg-[var(--ivory)]" style={{ left: `${pos}%` }} />
      <button
        type="button"
        role="slider"
        aria-label="Confronto prima e dopo: sposta il divisore"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(pos)}
        aria-valuetext={`${Math.round(pos)}% immagine prima`}
        data-testid={`${testid}-handle`}
        onKeyDown={onKey}
        className="absolute top-1/2 flex h-12 w-12 -translate-x-1/2 -translate-y-1/2 cursor-ew-resize items-center justify-center rounded-full border-2 border-[var(--brass)] bg-[var(--ivory)] text-[var(--brass-text)] shadow-lg focus-visible:outline-[var(--petrol)]"
        style={{ left: `${pos}%` }}
      >
        <span aria-hidden="true" className="text-lg">‹ ›</span>
      </button>
    </div>
  );
}
